var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.registerCompanyUser)?_c('section',[_c('LinkFirstCompany')],1):_c('section',[_c('RegisterEmpresa')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }